export default {
  SET_PARTNER_DATA: '@YOLA_TEMPLATE_GALLERY/PARTNER/SET_PARTNER_DATA',
};
